import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Revise = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 20 20" {...props}>
    <path
      d="M12.25 15.0625H9.4375V17.875"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0002 15.6122C17.7023 16.4828 17.1254 17.2307 16.3591 17.7399C15.5927 18.2492 14.6797 18.4912 13.7617 18.4286C12.8437 18.3659 11.9721 18.0021 11.282 17.3934C10.592 16.7848 10.122 15.9655 9.94519 15.0625"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.625 12.8125H18.4375V10"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.87476 12.2628C10.1727 11.3922 10.7495 10.6443 11.5159 10.1351C12.2823 9.62588 13.1952 9.38382 14.1132 9.44647C15.0312 9.50912 15.9029 9.87299 16.5929 10.4816C17.283 11.0902 17.7529 11.9096 17.9298 12.8125"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.1875 16.1875H2.6875C2.38913 16.1875 2.10298 16.069 1.892 15.858C1.68103 15.647 1.5625 15.3609 1.5625 15.0625V2.6875C1.5625 2.38913 1.68103 2.10298 1.892 1.892C2.10298 1.68103 2.38913 1.5625 2.6875 1.5625H10.6592C10.9574 1.56256 11.2434 1.68099 11.4543 1.89175L13.6083 4.04575C13.819 4.25665 13.9374 4.54259 13.9375 4.84075V7.1875"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
